









import { Component, Prop, Vue, Provide } from 'vue-property-decorator'
import { Col } from 'ant-design-vue'
import DetailListItem from './DetailListItem.vue'
import { VueClass } from 'vue-class-component/lib/declarations'

@Component({
  name: 'DescriptionList',
  components: {
    Col
  }
})
export default class DescriptionListComponent extends Vue {
  @Prop({ type: String, default: '', required: false })
  public title!: string
  @Prop({ type: Number, default: 3, required: false })
  public col!: number
  @Prop({ type: String, default: 'large', required: false })
  public size!: string
  @Prop({ type: String, default: 'horizontal', required: false })
  public layout!: string

  constructor() {
    super()
  }

  @Provide()
  colNumber = this.col
}
